// translate.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { GetText } from './get-text';

@Pipe({
  name: 'translate',
  standalone: true,
})
export class TranslatePipe implements PipeTransform {
  constructor(public getText: GetText) {}

  transform(key: string): string {
    return this.getText.getTranslation(key);
  }
}
